import { cn } from "@/lib/utils";

export default function FastlaneWatermark({
  className = "",
}: {
  className?: string;
}) {
  return (
    <img
      src="https://www.paypalobjects.com/fastlane-v1/assets/fastlane-with-tooltip_en_sm_light.0808.svg"
      alt="Fastlane by PayPal"
      className={cn("inline-block h-3 w-auto align-middle", className)}
    />
  );
}
